import SmoothScroll from 'smooth-scroll'

const AnimationManager = (() => {
  const initSmooth = () => {
    const scroll = new SmoothScroll('a[href^="#"]', {
      header: '.c-nav',
      topOnEmptyHash: true,
      speed: 500,
      clip: true,
      easing: 'easeInOutCubic',
      updateURL: false,
    })
  }

  const init = () => {
    initSmooth()
  }

  return {
    init
  }
})()

export default AnimationManager



// WEBPACK FOOTER //
// app/javascript/scripts/components/AnimationManager.js